import React from 'react';
import styles from './LayoutMobile.module.scss';
import cn from 'classnames';

export interface LayoutMobileProps extends JSX.ElementChildrenAttribute {
  className?: string
}
function LayoutMobile({ className, children }: LayoutMobileProps) {
  return (
    <div className={cn(styles.page, className)}>
      { children }
    </div>
  )
}

export default LayoutMobile;